<div>
  @if (!showLoader) {
  <div class="avatar-info">
    <div class="base-info" style="position: relative">
      <div class="col-md-4 d-flex align-items-start">
        <span
          class="user-avatar"
          [ngStyle]="{
            width: '60px',
            'min-width': '60px',
            height: '60px'
          }"
        >
          @if (!avatarDetails?.profile) {
          <span class="font-26">{{
            avatarDetails?.firstname?.charAt(0)?.toUpperCase() +
              "" +
              avatarDetails?.lastname?.charAt(0)?.toUpperCase()
          }}</span>
          }
          @if (avatarDetails?.profile) {
          <img
            [src]="avatarDetails?.profile"
            alt=""
          />
          }
        </span>
      </div>
      <div class="col-md-8 ps-0">
        <h4 class="heading mb-0">
          {{ avatarDetails?.firstname }} {{ avatarDetails?.lastname }}
        </h4>
      </div>
    </div>
  </div>
  } @else {
    <div class="avatar-popup-loader">
      <nz-spin nzSimple></nz-spin>
    </div>
  }
</div>
